export default "__VITE_ASSET__Bd06skTX__"